import { Stack } from '@mui/material';
import { ComponentProps, ReactNode } from 'react';
import { HeaderBreadcrumbs } from './HeaderBreadcrumbs';

export type MainLayoutProps = {
  children?: ReactNode;
  breadcrumbs: ComponentProps<typeof HeaderBreadcrumbs>['breadcrumbs'];
};

export const MainLayout = (props: MainLayoutProps) => {
  return (
    <Stack id="redesign-layout" sx={{ marginX: '1.25rem' }} gap={1}>
      <HeaderBreadcrumbs breadcrumbs={props.breadcrumbs} />
      {props.children}
    </Stack>
  );
};
